import NewPartnerForm from "components/Forms/PartnerForm/PartnerForm";

const NieuwePartner = () => {
  return <NewPartnerForm />;
};

export default NieuwePartner;
